"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.getUniqueFormats = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _excerpts = _interopRequireDefault(require("excerpts"));

var _TopicIcon = _interopRequireDefault(require("../../templates/TopicIcon"));

var _DataIcon = _interopRequireDefault(require("../DataIcon"));

var _Text = _interopRequireDefault(require("../Text"));

var _router = require("@reach/router");

var _countBy = require("lodash/countBy")



/* eslint-disable */
var SearchListItem = function SearchListItem(_ref) {
  var className = _ref.className,
    item = _ref.item,
    color = _ref.color;
  var ref = item.ref,
    title = item.title,
    description = item.description,
    format = item.format,
    theme = item.theme,
    modified = item.modified,
    issued = item.issued;

  function formats(distribution) {
    if (!distribution) {
      return null;
    }

    if ((0, _typeof2["default"])(distribution) === 'object' || Array.isArray(distribution)) {
      var distributionWithUniqueFormats = getUniqueFormats(Object.entries(distribution));
      const counted = _countBy(distribution, (d) => {
        return d.format;
      });

      return distributionWithUniqueFormats.map(function (dist, idx) {
        var type = dist.mediaType ? dist.mediaType.split('/') : '';
        var backup = type ? type : 'data';
        var format = dist.format ? dist.format : backup;
        var finishIcon = '';
        switch (format.toLowerCase()) {
          case 'pdf':
            finishIcon = 'fa-solid fa-file-pdf'
            break;
          case 'csv':
            finishIcon = 'fa-solid fa-file-csv'
            break;
          case 'zip':
            finishIcon = 'fa-solid fa-file-zipper'
            break;
          case 'json':
            finishIcon = 'fa-solid fa-file-code'
            break;
          case 'tablero':
            finishIcon = 'fa-solid fa-chart-area'
            break;
          case 'html':
            finishIcon = 'fa-brands fa-html5'
            break;
          case 'data':
            finishIcon = 'fa-solid fa-file-archive'
            break;
        }

        return  /*#__PURE__*/_react["default"].createElement("span", {
          key: idx,
          style: { marginRight: '1.5rem', display: 'inline-flex', alignItems: 'center' }
        },
          _react["default"].createElement("i", {
            className: "mr-2 " + finishIcon,
            title: format
          }),
          _react["default"].createElement("span", {
            style: { fontWeight: '600', fontSize: '1.3rem' }
          },
            format.toUpperCase()
          ),
          _react["default"].createElement("span", {
            className: "totalFormat",
            key: "total" + idx
          },
            ` (x${counted[format]})`
          )
        );
      });
    }

    return null;
  }

  ;

  function themes(theme) {
    if (!theme) {
      return null;
    } else {
      return theme.map(function (topic, idx) {
        return  /*#__PURE__*/_react["default"].createElement('span', { className: 'mr-2', title: topic },
          _react["default"].createElement('span', { className: 'mr-2' }, topic),
          /*#__PURE__*/_react["default"].createElement(_TopicIcon["default"], {
            title: topic,
            height: 15,
            width: 15,
            color: color
          }))
      });
    }
  }

  function publishers(publisher) {
    if (!publisher) {
      return null;
    } else {
      return /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_DataIcon["default"], {
        icon: "group",
        height: 20,
        width: 20
      }), publisher);
    }
  }

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: className
  }, /*#__PURE__*/_react["default"].createElement("div", { className: 'results-card-header' }, /*#__PURE__*/_react["default"].createElement(_router.Link, {
    className: 'title title--primary-dark',
    to: ref
  }, title),  /*#__PURE__*/_react["default"].createElement('p', {
    className: 'text text-primary'
  }, /*#__PURE__*/_react["default"].createElement(_router.Link, {
    to: ref
  },  /*#__PURE__*/_react["default"].createElement('i', {
    className: 'fa-solid fa-eye'
  }), ' Ver Informe'))),
   /*#__PURE__*/_react["default"].createElement('div', {
    className: 'results-card-body'
  }, description && /*#__PURE__*/_react["default"].createElement("p", {
    className: "text text--black margin-bottom"
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], null, (0, _excerpts["default"])(description, {
    words: 35
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "results-data"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "results-headings"
  },  issued && /*#__PURE__*/_react["default"].createElement('p', null, "Fecha de publicación"), /*#__PURE__*/_react["default"].createElement('p', null, "Última modificación"),   /*#__PURE__*/_react["default"].createElement('p', null, "Formato")),
  /*#__PURE__*/_react["default"].createElement("div", {
    className: "results-info"
  },  issued && /*#__PURE__*/_react["default"].createElement('p', null, issued), /*#__PURE__*/_react["default"].createElement('p', null, modified), /*#__PURE__*/_react["default"].createElement('p', null, format && formats(format))))),
  /*#__PURE__*/_react["default"].createElement('div', {
    className: 'results-card-footer'
  },/*#__PURE__*/_react["default"].createElement('div', {
    className: 'result-tag'
  }, /*#__PURE__*/_react["default"].createElement('p', { className: 'text text--black' }, "Categorias / Etiquetas:  ", theme && themes(theme)))));
};

var getUniqueFormats = function getUniqueFormats(formats) {
  var unique = [];
  return formats.reduce(function (a, b) {
    if (unique.indexOf(b[1].format) === -1) {
      unique.push(b[1].format);
      a.push(b[1]);
    }
    return a;
  }, []);
};

exports.getUniqueFormats = getUniqueFormats;
SearchListItem.defaultProps = {
  className: 'results-card'
};
SearchListItem.propTypes = {
  className: _propTypes["default"].string,
  item: _propTypes["default"].objectOf(_propTypes["default"].any).isRequired
};
var _default = SearchListItem;
exports["default"] = _default;